import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { FaEdit } from 'react-icons/fa';
import CultureTenetsEditModal from './components/CultureTenetsEditModal';
import './CultureTenets.scss';

const CultureTenets = () => {
  const [tenetsContent, setTenetsContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  
  const { user } = useSelector(state => state.auth);
  const isAdmin = user?.userType === "admin";

  useEffect(() => {
    fetchTenetsContent();
  }, []);

  const fetchTenetsContent = async () => {
    try {
      setLoading(true);
      const docRef = doc(db, 'authUsers', 'webPages');
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        const data = docSnap.data();
        setTenetsContent(data.cultureLeadershipPrinciple || '');
      } else {
        setError('Culture & Tenets content not found.');
      }
      
      setLoading(false);
    } catch (err) {
      console.error('Error fetching Culture & Tenets content:', err);
      setError('Failed to load Culture & Tenets content. Please try again later.');
      setLoading(false);
    }
  };

  const handleUpdateContent = (newContent) => {
    setTenetsContent(newContent);
    setShowEditModal(false);
  };

  return (
    <div className="culture-tenets-container">
      <div className="page-header">
        <div className="header-content">
          <h1>Culture & Tenets</h1>
          <p>The principles that guide us and define our work at MyelinZ</p>
        </div>
        
        {isAdmin && (
          <button 
            className="edit-tenets-btn" 
            onClick={() => setShowEditModal(true)}
          >
            <FaEdit /> Edit Culture & Tenets
          </button>
        )}
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading content...</p>
        </div>
      ) : error ? (
        <div className="error-message">
          <p>{error}</p>
        </div>
      ) : (
        <div className="culture-content">
          {tenetsContent ? (
            <div 
              className="tenets-html-content" 
              dangerouslySetInnerHTML={{ __html: tenetsContent }}
            />
          ) : (
            <div className="no-tenets-content">
              <p>No Culture & Tenets content available. {isAdmin && 'Click the Edit button to add content.'}</p>
            </div>
          )}
        </div>
      )}

      {showEditModal && (
        <CultureTenetsEditModal 
          initialContent={tenetsContent}
          onClose={() => setShowEditModal(false)}
          onSave={handleUpdateContent}
        />
      )}
    </div>
  );
};

export default CultureTenets; 